// Module
var code = "<p>Enable this setting to hide geographical reach chart containing geographical statistics regarding your participants.</p> ";
// Exports
module.exports = code;